<template>
  <div class="flow">
    <div class="main-page">
      <div class="title show-pc">
        <span>公司转让平台</span>
      </div>
      <div class="btn-group show-pc">
        <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline" @click="apply">发布</el-button>
        <el-popover placement="top" width="160" v-model="visible">
          <div style="text-align: center; margin: 0">
            <ul class="option">
              <li @click="toOwn">我的发布</li>
              <li v-if="userInfo.id" @click="loginOut">退出登录</li>
            </ul>
          </div>
          <div class="own" slot="reference">
            <el-avatar icon="el-icon-user-solid"></el-avatar>
          </div>
        </el-popover>
      </div>
      <SearchForm ref="searchForm" :search-form="searchForm" @search="search" @reset="reset"></SearchForm>
      <TheList
        :right-width="'80px'"
        :data="tableData"
        :page="searchForm.page"
        :size="searchForm.limit"
        :total="searchForm.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @search="search"
        @cellClick="cellClick"
        @handleEdit="handleEdit"
        @handleDetail="handleDetail"
        :finished="finished"
        :listloading="loading"
        :refreshing="refreshing"
        @onLoad="onLoad"
        @refresh="onRefresh"
      >
        <template v-slot:button="{ scope }">
          <el-button
            size="mini"
            type="primary"
            plain
            @click="handleDetail(scope.$index, scope.row.flow)"
            >详细</el-button
          >
        </template>
      </TheList>
    </div>
  </div>
</template>

<script>
import cityData from '../../utils/Data'
import TheList from './components/TheList'
import SearchForm from './components/SearchForm'
import moment from 'moment'
export default {
  name: 'Flow',
  components: {
    TheList: TheList,
    SearchForm: SearchForm
  },
  data() {
    return {
      userInfo: {},
      tableData: [],
      searchForm: {
        page: 1,
        limit: 10,
        companyName: '',
        infoType: '', // 信息类型
        establishmentTimeSelect: '',
        establishmentTimeA: '', // 成立开始时间
        establishmentTimeB: '', // 成立最后时间
        establishmentTimeA2: new Date(), // 成立开始时间
        establishmentTimeB2: new Date(), // 成立最后时间
        establishmentTimeShowA2: this.timeFormat(new Date(), 'yyyy-MM-dd'), // 成立开始时间
        establishmentTimeShowB2: this.timeFormat(new Date(), 'yyyy-MM-dd'), // 成立最后时间
        registeredCapitalA: '', // 最少注册资金
        registeredCapitalB: '', // 最多注册资金
        taxNature: '',
        address: '', // 地址
        province: '', // 省
        city: '', // 市
        county: '', // 区
        provinceName: '', // 区
        cityName: '', // 区
        countyName: '', // 区
        natureBusiness: '', // 区
        publicTimeA: '', // 上架开始时间
        publicTimeB: '', // 上架最后时间
        industries: [], // 负责人数组
        isPublic: '', // 是否上架
        time: ''
      },
      companys: [],
      taxs: [
        { code: '小规模', name: '小规模' },
        { code: '一般纳税人', name: '一般纳税人' }
      ],
      persons: [],
      cycle2: [
        { code: 0, name: '到期' },
        { code: '30', name: '30天' },
        { code: '60', name: '60天' },
        { code: '90', name: '90天' },
        { code: '120', name: '120天' },
        { code: '180', name: '180天' }
      ],
      cycle: [
        { roleId: '月付', roleName: '月付' },
        { roleId: '季付', roleName: '季付' },
        { roleId: '半年付', roleName: '半年付' },
        { roleId: '年付', roleName: '年付' }
      ],
      jobs: [
        { text: '所有行业', value: '' },
        { text: '生产', value: '生产' },
        { text: '销售', value: '销售' },
        { text: '研发', value: '研发' },
        { text: '服务', value: '服务' }
      ],
      loading: false,
      options: cityData,
      options1: [],
      options2: [],
      options3: [],
      areaList: {},
      popup1ShowState: false,
      popup2ShowState: false,
      popup3ShowState: false,
      fileList: [],
      drawer: false,
      finished: false,
      refreshing: false,
      visible: false
    }
  },
  computed: {
    time: function() {
      console.log(this.searchForm.establishmentTimeA, this.searchForm.establishmentTimeB)
      if (this.searchForm.establishmentTimeA && this.searchForm.establishmentTimeB) {
        return [this.searchForm.establishmentTimeA, this.searchForm.establishmentTimeB].join('至')
      } else {
        return ''
      }
    }
  },
  methods: {
    timeFormat(date, format) {
      if (!date) {
        return ''
      }
      // 日期解析
      var o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds() // 毫秒
      }
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
        }
      }
      return format
    },
    reset() {
      this.searchForm = {
        page: 1,
        limit: 10,
        companyName: '',
        infoType: '', // 信息类型
        establishmentTimeSelect: '',
        establishmentTimeA: '', // 成立开始时间
        establishmentTimeB: '', // 成立最后时间
        establishmentTimeA2: new Date(), // 成立开始时间
        establishmentTimeB2: new Date(), // 成立最后时间
        establishmentTimeShowA2: this.timeFormat(new Date(), 'yyyy-MM-dd'), // 成立开始时间
        establishmentTimeShowB2: this.timeFormat(new Date(), 'yyyy-MM-dd'), // 成立最后时间
        registeredCapitalA: '', // 最少注册资金
        registeredCapitalB: '', // 最多注册资金
        taxNature: '',
        address: '', // 地址
        province: '', // 省
        city: '', // 市
        county: '', // 区
        provinceName: '', // 区
        cityName: '', // 区
        countyName: '', // 区
        natureBusiness: '', // 区
        publicTimeA: '', // 上架开始时间
        publicTimeB: '', // 上架最后时间
        industries: [], // 负责人数组
        isPublic: '', // 是否上架
        time: ''
      }
      this.search(1)
    },
    // 表格点击当前行
    cellClick(row, column, cell, event) {
      if (column.label !== '操作' && column.label !== '图片') {
        this.handleDetail(column.index, row.flow)
      }
    },
    // 行业 popup 选择变化
    industriesChange(val) {
      console.log(val)
      console.log(this.searchForm.industries)
      this.$refs.item2.toggle()
      this.search(1)
    },
    /**
     * 查询变更项
      system/code/query?systemId=0&businessId=0
      纳税性质
      system/code/query?systemId=0&businessId=1
      计费周期
      system/code/query?systemId=0&businessId=2
      案件状态
      system/code/query?systemId=0&businessId=3
      案件类型
      system/code/query?systemId=0&businessId=4
      案件业务类型
      system/code/query?systemId=0&businessId=5
    */
    queryCode(businessId) {
      const param = {
        systemId: 0,
        businessId: businessId
      }
      this.$get('/system/code/query', param).then(
        result => {
          if (result.status === 200) {
            if (businessId === 0) {
              this.changs = result.data
            } else if (businessId === 1) {
              this.taxs = result.data
            } else if (businessId === 2) {
              this.cycle = result.data
            } else if (businessId === 3) {
              this.states = result.data
            } else if (businessId === 4) {
              this.caseTypes = result.data
            } else if (businessId === 5) {
              this.businessTypes = result.data
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询全国区域
    queryProvinceCity() {
      const param = {}
      this.$get('/system/queryProvinceCity', param).then(
        result => {
          if (result.status === 200) {
            this.options = result.data
            this.areaList = []
            const provincelist = []
            const citylist = []
            const countylist = []
            for (let i = 0; i < this.options.length; i++) {
              // 省
              provincelist[this.options[i].value] = this.options[i].label
              for (let j = 0; j < this.options[i].children.length; j++) {
                citylist[this.options[i].children[j].value] = this.options[i].children[j].label
                // 市
                for (let k = 0; k < this.options[i].children[j].children.length; k++) {
                  // 区
                  countylist[this.options[i].children[j].children[k].value] = this.options[i].children[j].children[
                    k
                  ].label
                }
              }
            }
            for (let i = 0; i < this.tableData.length; i++) {
              for (let j = 0; j < this.options.length; j++) {
                // 省
                if (this.tableData[i].flow.province === this.options[j].value) {
                  this.tableData[i].flow.provinceName = this.options[j].label
                  for (let k = 0; k < this.options[j].children.length; k++) {
                    // 市
                    if (this.tableData[i].flow.city === this.options[j].children[k].value) {
                      this.tableData[i].flow.cityName = this.options[j].children[k].label
                      for (let l = 0; l < this.options[j].children[k].children.length; l++) {
                        // 区
                        if (this.tableData[i].flow.county === this.options[j].children[k].children[l].value) {
                          this.tableData[i].flow.countyName = this.options[j].children[k].children[l].label
                        }
                      }
                    }
                  }
                }
              }
            }
            this.areaList = {
              province_list: provincelist,
              city_list: citylist,
              county_list: countylist
            }
            console.log(this.areaList)
            this.tableData = [...this.tableData]
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询列表
    queryList() {
      let establishmentTimeA = ''
      let establishmentTimeB = ''
      // const now = new Date()
      if (this.searchForm.establishmentTimeSelect === '1') {
        establishmentTimeA = moment()
          .subtract(1, 'year')
          .format('YYYY-MM-DD')
        establishmentTimeB = moment().format('YYYY-MM-DD')
      } else if (this.searchForm.establishmentTimeSelect === '2') {
        establishmentTimeA = moment()
          .subtract(3, 'year')
          .format('YYYY-MM-DD')
        establishmentTimeB = moment()
          .subtract(1, 'year')
          .format('YYYY-MM-DD')
      } else if (this.searchForm.establishmentTimeSelect === '3') {
        establishmentTimeA = moment()
          .subtract(5, 'year')
          .format('YYYY-MM-DD')
        establishmentTimeB = moment()
          .subtract(3, 'year')
          .format('YYYY-MM-DD')
      } else if (this.searchForm.establishmentTimeSelect === '4') {
        establishmentTimeA = moment()
          .subtract(10, 'year')
          .format('YYYY-MM-DD')
        establishmentTimeB = moment()
          .subtract(5, 'year')
          .format('YYYY-MM-DD')
      } else if (this.searchForm.establishmentTimeSelect === '5') {
        establishmentTimeA = moment()
          .subtract(100, 'year')
          .format('YYYY-MM-DD')
        establishmentTimeB = moment()
          .subtract(10, 'year')
          .format('YYYY-MM-DD')
      } else if (this.searchForm.establishmentTimeSelect === '6') {
        establishmentTimeA = this.searchForm.establishmentTimeA
        establishmentTimeB = this.searchForm.establishmentTimeB
      }
      const param = {
        page: this.searchForm.page,
        limit: this.searchForm.limit,
        companyName: this.searchForm.companyName,
        infoType: this.searchForm.infoType,
        establishmentTimeA: establishmentTimeA,
        establishmentTimeB: establishmentTimeB,
        registeredCapitalA: this.searchForm.registeredCapitalA,
        registeredCapitalB: this.searchForm.registeredCapitalB,
        address: this.searchForm.address,
        province: this.searchForm.province,
        city: this.searchForm.city,
        county: this.searchForm.county,
        publicTimeA: this.searchForm.publicTimeA,
        publicTimeB: this.searchForm.publicTimeB,
        industries: this.searchForm.industries,
        isPublic: this.searchForm.isPublic,
        natureBusiness: this.searchForm.natureBusiness,
        taxNature: this.searchForm.taxNature
      }
      this.$common.session.set('flow-search', this.searchForm)
      this.loading = true
      this.$post('/flowOut/queryAll', param).then(
        result => {
          this.loading = false
          this.refreshing = false
          if (result.status === 200) {
            this.searchForm.total = result.num
            this.tableData = result.data
            this.queryProvinceCity()
            if (this.tableData.length >= result.num) {
              this.finished = true
              console.log(this.finished)
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.loading = false
          this.refreshing = false
          this.drawer = false
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 每页条数切换
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.searchForm.limit = val
      this.search()
    },
    // 页码切换
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.searchForm.page = val
      this.search()
    },
    // 查询
    search(page) {
      if (page) {
        this.searchForm.page = page
      }
      // 查询
      this.queryList()
    },
    // 移动端列表加载
    onLoad(type) {
      console.log(type)
      const param = {
        page: this.searchForm.page,
        limit: this.searchForm.limit,
        companyName: this.searchForm.companyName,
        infoType: this.searchForm.infoType,
        establishmentTimeA: this.searchForm.establishmentTimeA,
        establishmentTimeB: this.$common.timeFormat(new Date(), 'yyyy-MM-dd'),
        registeredCapitalA: this.searchForm.registeredCapitalA,
        registeredCapitalB: this.searchForm.registeredCapitalB,
        address: this.searchForm.address,
        province: this.searchForm.province,
        city: this.searchForm.city,
        county: this.searchForm.county,
        publicTimeA: this.searchForm.publicTimeA,
        publicTimeB: this.searchForm.publicTimeB,
        industries: this.searchForm.industries,
        isPublic: this.searchForm.isPublic,
        natureBusiness: this.searchForm.natureBusiness,
        taxNature: this.searchForm.taxNature
      }
      this.$post('/flowOut/queryAll', param).then(
        result => {
          this.loading = false
          this.refreshing = false
          if (result.status === 200) {
            if (type === 'onRefresh') {
              this.searchForm.total = result.num
              this.tableData = result.data
            } else {
              this.tableData = this.tableData.concat(result.data)
            }
            console.log(this.tableData)
            this.searchForm.page++
            if (this.tableData.length >= result.num) {
              this.finished = true
            }
          } else {
            console.log(result.msg)
          }
        },
        error => {
          this.refreshing = false
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 移动端刷新
    onRefresh() {
      this.refreshing = true
      console.log(this.refreshing)
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.searchForm.page = 1
      this.onLoad('onRefresh')
    },
    apply() {
      this.$router.push({
        name: 'FlowPublicBySelfDetail',
        params: {
          id: null,
          webState: 'add'
        }
      })
    },
    toOwn() {
      this.$router.push({
        name: 'FlowPublicBySelf'
      })
    },
    loginOut() {
      this.$root.$children[0].vueConfirm(
        { message: '确定退出登录吗？', title: '提示', type: 'warning' },
        () => {
          this.$common.session.clear()
          this.$router.push('/loginToFlow')
        },
        () => {}
      )
    },
    // 客户新增点击
    add() {
      this.$router.push({
        name: 'FlowPublicDetail',
        params: {
          id: null,
          webState: 'add'
        }
      })
    },
    // 客户编辑
    handleEdit(index, row) {
      this.$router.push({
        name: 'FlowPublicDetail',
        params: {
          id: row.id,
          webState: 'detail'
        }
      })
    },
    // 客户详情
    handleDetail(index, row) {
      this.$router.push({
        name: 'FlowPublicDetail',
        params: {
          id: row.id,
          webState: 'detail'
        }
      })
    },
    // 删除客户
    handleDelete(index, row) {
      this.$root.$children[0].vueConfirm(
        { message: '确认要删除此客户吗?' },
        () => {
          const param = {
            id: row.id
          }
          this.$get('/flow/delete', param).then(
            result => {
              if (result.status === 200) {
                this.search()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        },
        () => {
          return console.log('取消删除')
        }
      )
    },
    // 查询 ： 区域更改
    searchQyChange(val) {
      console.log(val)
      if (val) {
        this.searchForm.province = val[0]
        this.searchForm.city = val[1]
        this.searchForm.county = val[2]
      }
    }
  },
  mounted() {
    document.title = '公司转让平台'
    if (this.$common.session.get('userInfo')) {
      this.userInfo = this.$common.session.get('userInfo')
    }
    if (this.$common.session.get('flow-search')) {
      this.searchForm = this.$common.session.get('flow-search')
      this.searchForm.establishmentTimeA2 = new Date()
      this.searchForm.establishmentTimeB2 = new Date()
      if (this.searchForm.qy) {
        this.searchForm.county = this.searchForm.qy[0] ? this.searchForm.qy[0] : ''
        this.searchForm.city = this.searchForm.qy[1] ? this.searchForm.qy[1] : ''
        this.searchForm.county = this.searchForm.qy[2] ? this.searchForm.qy[2] : ''
      }
    }
    for (let i = 0; i < this.options.length; i++) {
      this.options1.push({
        label: this.options[i].label,
        text: this.options[i].label,
        value: this.options[i].label
      })
    }
    this.queryList() // 列表查询
    this.queryCode(1)
    this.queryCode(2)
    if (this.searchForm.county) {
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].text === this.searchForm.county) {
          const index = i
          const vals = this.options[i]
          vals.city = vals.children
          this.$refs.searchForm.pickerConfirm1(vals, index)
          if (this.searchForm.city) {
            for (let j = 0; j < vals.children.length; j++) {
              if (vals.children[j].text === this.searchForm.city) {
                const index2 = j
                const vals2 = vals.children[j]
                vals2.city = vals2.children
                this.$refs.searchForm.pickerConfirm2(vals2, index2)
                if (this.searchForm.county) {
                  for (let k = 0; k < vals2.children.length; k++) {
                    if (vals2.children[k].text === this.searchForm.county) {
                      const index3 = k
                      const vals3 = vals2.children[k]
                      this.$refs.searchForm.pickerConfirm3(vals3, index3)
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  beforeDestroy() {}
}
</script>

<style lang="less" scoped>
.el-radio-group {
  /deep/.el-radio {
    margin-right: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
    .el-radio__label {
      padding-left: 0;
    }
    .el-radio__input {
      display: none;
    }
  }
  .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0;
  }
}

.show-phone {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
    .el-input__prefix {
      height: 34px;
    }
  }
}
.el-autocomplete-suggestion.el-popper {
  width: 300px !important;
}
.import-btn {
  position: relative;
  .import-excel {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    left: 0;
    top: 0;
  }
}
.edit-page,
.main-page {
  height: 100%;
}
.flow {
  padding: 0 20px;
}
.title {
  text-align: center;
  font-size: 28px;
  padding: 24px 0 14px;
}
.btn-group {
  position: absolute;
  top: 1vh;
  right: 2vw;
  display: flex;
  align-items: center;
  .own {
    margin-left: 2vw;
    font-size: 16px;
    display: flex;
    align-items: center;
  }
}
.option {
  list-style: none;
  li {
    height: 30px;
    line-height: 30px;
  }
  li:hover {
    cursor: pointer;
    background-color: #f0f0f0;
    color: #1890ff;
  }
}
.picker-show {
  display: flex;
}
.picker-pannel {
  display: flex;
  .date-pannel {
    margin-right: 10px;
  }
}
.search-box {
  background: #fff;
  padding: 10px 20px 10px 0;
  margin-bottom: 12px;
  /deep/.el-input__inner,
  .el-textarea__inner {
    border-radius: 0;
  }
  /deep/.el-checkbox__inner {
    display: none;
  }
}
.btn-search {
  display: flex;
  margin: 0 auto;
  justify-content: center;
  .simple {
    width: 550px;
    margin-bottom: 20px;
  }
  .advanced {
    cursor: pointer;
    width: 100px;
    margin-left: 10px;
    color: black;
    text-decoration: underline;
    font-size: 14px;
    // line-height: 50px;
  }
  /deep/.el-input-group__append,
  /deep/.el-input-group__prepend {
    color: #fff;
    background-color: #1890ff;
    border-color: #1890ff;
  }
  .el-button {
    color: #fff;
    background-color: #1890ff;
    border-color: #1890ff;
  }
}
.advanced {
  cursor: pointer;
  width: 100px;
  margin-left: 10px;
  color: black;
  text-decoration: underline;
  font-size: 14px;
  margin-bottom: 10px;
}
.phone-list {
  color: #000;
  li {
    padding: 0 10px;
    border-bottom: 1px solid #eee;
    background: #fff;
    .title {
      display: flex;
      font-size: 0.8vw;
      font-weight: normal;
      text-align: left;
      padding: 0;
      padding-top: 10px;
      justify-content: space-between;
      .text {
        width: calc(100% - 100px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 2;
      }
      .phone {
        a {
        }
      }
    }
    .label {
      /deep/.el-tag {
        margin-right: 10px;
      }
    }
    .content {
      display: flex;
      justify-content: center;
      margin-top: 10px;
      .item {
        width: 33%;
        text-align: center;
        line-height: 2;
        .label {
          color: #666;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .title {
    font-weight: 700;
    font-size: 1.4rem !important;
    line-height: 2 !important;
    margin-bottom: 0;
    height: auto !important;
  }
  .flow {
    padding: 0 0 20px;
  }
  .search-box {
    background: #fff;
    padding: 10px 0;
  }
  .btn-search {
    padding-top: 0;
  }
}
</style>
